import { render, staticRenderFns } from "./FeedDataEntryAdd.vue?vue&type=template&id=5c4940b0&scoped=true&"
import script from "./FeedDataEntryAdd.vue?vue&type=script&lang=js&"
export * from "./FeedDataEntryAdd.vue?vue&type=script&lang=js&"
import style0 from "./FeedDataEntryAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4940b0",
  null
  
)

export default component.exports